export const Role = {
    MASTER: "master",
    SUPER_USER: "super_user",
    ADMIN: "admin"
  };